import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage id="signup.header-2" defaultMessage="Create your IDAGIO account" />
);
